import { LOADING } from "./types";

export const stopLoading = () => {
  return {
    type: LOADING,
    payload: false,
  };
};
